/**
 * Free R4x
 */
export const FREEMAGSTRIPE = 'FREEMAGSTRIPE';

/**
 * R4x Pricing Experiment SHOP-4780
 */
export const PROMOMAGSTRIPE = 'PROMOMAGSTRIPE';

/**
 * JP NTS 2025 promotion
 */
export const SALE2025 = 'sale2025';

/**
 * US NTS 2025 promotion
 */
export const NEWDEVICE = 'NEWDEVICE';

/**
 * GB NTS 2025 promotion
 */
export const SPRING2025 = 'SPRING2025';

export const ACTIVE_PROMOTIONS = {
  [PROMOMAGSTRIPE]: {
    priority: 1,
    appliesTo: [
      // US products
      'magstripe-reader',
      'credit-card-reader',
      'magstripe-credit-card-reader-usb-c',
    ],
  },

  // TODO (@omose): Phase out FREEMAGSTRIPE
  [FREEMAGSTRIPE]: {
    priority: 1,
    appliesTo: [
      // US products
      'magstripe-reader',
      'credit-card-reader',
      'magstripe-credit-card-reader-usb-c',
    ],
  },
  [SALE2025]: {
    priority: 1,
    appliesTo: [
      // JP products
      'credit-card-reader-jp',
      'card-payment-terminal-jp',
    ],
  },
  [NEWDEVICE]: {
    priority: 1,
    appliesTo: [
      // US products
      'register-pos',
      'terminal-credit-card-machine',
      'ipad-pos-stand-integrated-card-reader-usb-c',
      'self-service-kiosk-machine-v2',
      'chip-credit-card-reader-with-nfc',
    ],
  },
  [SPRING2025]: {
    priority: 1,
    appliesTo: [
      // GB products
      'register-pos-gb',
      'terminal-credit-card-machine-gb',
	    'ipad-pos-stand-integrated-card-reader-usb-c-gb',
	    'self-service-kiosk-machine-gb',
	    'credit-card-apple-pay-reader-contactless',
    ],
  },
};
